import React, {Fragment, useState, useEffect} from 'react'
import {useFirestore} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import {env} from '../../../constants/Environment';
import * as RouterActions from '../../../actions/RouterActions';
import * as StructureActions from '../../../actions/canvas/StructureActions';
import { Table, Placeholder, Accordion, Label, Menu } from 'semantic-ui-react'
import {Market} from './market';
import {CanvasNavigation} from '../Navigation';
import * as STATUS_TO_COLOR from '../../../constants/StatusToColor'
import ReactJson from 'react-json-view'
import {Results} from './results'

var moment = require('moment');
require('moment/locale/de');

export function EventDetails(props){
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const [event, setEvent] = useState(null);
    const [date, setDate] = useState(null);
    const [activeMarket, setActiveMarket] = useState();
    const [activeTab, setActiveTab] = useState('event');
    const [canvasData, setCanvasData] = useState(null);

    const existingStructure = useSelector(({canvas_structure}) => ({
            sport: Object.keys(canvas_structure.sport),
            category: Object.keys(canvas_structure.category),
            tournament: Object.keys(canvas_structure.tournament)
        }));

    useEffect(() => {
        const unsubscribe = firestore.collection('environments/' + env + '/canvas/' + props.channel + '/oe').doc(props.id).onSnapshot((snapshot) => {
            setEvent(snapshot.data());
        });

        return unsubscribe;
    }, [props.channel, props.id]);

    useEffect(() => {
        if(event === null)return;

        dispatch(StructureActions.load_missing(firestore, props.channel, 'sport', existingStructure.sport, [event['sport-uid']]));
        dispatch(StructureActions.load_missing(firestore, props.channel, 'category', existingStructure.category, [event['category-uid']]));
        dispatch(StructureActions.load_missing(firestore, props.channel, 'tournament', existingStructure.tournament, [event['tournament-uid']]));
    }, [event]);

    useEffect(() => {
        if(activeTab === 'canvas' && canvasData === null){
            (async () => {
                let res = await firestore.collection(['environments', env, 'canvas', props.channel, 'events'].join('/')).doc(event['oddset-id']).get();
                if(res.exists)
                    setCanvasData(res.data());
            })();
        }
    }, [activeTab]);

    const sport = useSelector(({canvas_structure}) => (event !== null && typeof canvas_structure.sport[event['sport-uid']] !== 'undefined')?canvas_structure.sport[event['sport-uid']]:null);
    const category = useSelector(({canvas_structure}) => (event !== null && typeof canvas_structure.category[event['category-uid']] !== 'undefined')?canvas_structure.category[event['category-uid']]:null);
    const tournament = useSelector(({canvas_structure}) => (event !== null && typeof canvas_structure.tournament[event['tournament-uid']] !== 'undefined')?canvas_structure.tournament[event['tournament-uid']]:null);

    const showTab = (tab) => {
        setActiveTab(tab);
    };

    if(event === null)
        return (
            <Placeholder>
                <Placeholder.Line />
                <Placeholder.Line />
                <Placeholder.Line />
                <Placeholder.Line />
                <Placeholder.Line />
            </Placeholder>
        );

    return (
        <CanvasNavigation>
        <div style={{marginLeft: '15px', marginRight: '15px'}}>
            <Menu pointing secondary>
                <Menu.Item
                    name='Event-Details'
                    active={activeTab === 'event'}
                    onClick={(e) => showTab('event')}
                />
               <Menu.Item
                    name='KISaD JSON'
                    active={activeTab === 'json'}
                    onClick={(e) => showTab('json')}
                />
                <Menu.Item
                    name='Canvas'
                    active={activeTab === 'canvas'}
                    onClick={(e) => showTab('canvas')}
                />
            </Menu>

            {
                (activeTab === 'event')?
                    <div>
                        <h1>{event.name}</h1>

                        <h2>Meta</h2>
                        <div style={{
                            display: 'grid',
                            'grid-template-columns': '10em 1fr'
                        }}>
                            <div>Version</div>
                            <div>{event.meta.version}</div>
                            <div>Aktualisierung</div>
                            <div>{moment(event.meta['last-modified'].toDate()).format('DD.MM.YYYY HH:mm:ss')}</div>
                            <div>Uid</div>
                            <div>{event.uid}</div>
                            <div>Canvas-ID</div>
                            <div>{event['oddset-id']}</div>
                        </div>

                        <h2>Event-Details</h2>
                        <div style={{
                            display: 'grid',
                            'grid-template-columns': '10em 1fr'
                        }}>
                            <div>Spielnummer (PLUS)</div>
                            <div><Label color='blue'>{event['playing-numbers'].plus}</Label></div>
                            {
                                (event['playing-numbers'].kompakt !== null)?
                                    <Fragment>
                                        <div>Spielnummer (KOMPAKT)</div>
                                        <div><Label color='green'>{event['playing-numbers'].kompakt}</Label></div>
                                    </Fragment>
                                :null
                            }
                            <div>Bezeichnung</div>
                            <div>{event.name}</div>
                            <div>Annahmeschluss</div>
                            <div>{moment(event['active-to'].toDate()).format('dddd, DD.MM.YYYY, HH:mm [Uhr]')}</div>
                            <div>Status</div>
                            <div><div style={{
                                display: 'inline-block',
                                borderRadius: '5px',
                                color: '#000000',
                                padding: '3px 5px',
                                textAlign: 'center',
                                backgroundColor: (typeof STATUS_TO_COLOR[event.status] !== 'undefined')?STATUS_TO_COLOR[event.status]:'#FFFFFF'
                            }}>
                                {event.status}
                            </div></div>
                            {
                                (typeof event.teams !== 'undefined' && event.teams !== null)?
                                    event.teams.map((team, idx) => <Fragment><div>Team {idx + 1}</div><div>{team.name} ({team['oddset-id']})</div></Fragment>)
                                :null
                            }
                        </div>
                        <h2>Struktur</h2>
                        <div style={{
                            display: 'grid',
                            'grid-template-columns': '10em 1fr'
                        }}>
                            <div>Sportart</div>
                            <div>{(sport === null)
                                ?null
                                :(typeof sport.name !== 'undefined')
                                    ?sport.name
                                    :(typeof sport.canvas !== 'undefined' && typeof sport.canvas.name !== 'undefined')
                                        ?sport.canvas.name
                                        :(typeof sport.canvas.canvas !== 'undefined')
                                            ?sport.canvas.canvas.name
                                            :null}
                            </div>
                            <div>Kategorie</div>
                            <div>{
                                (category === null)
                                    ?null
                                    :(typeof category.name !== 'undefined')
                                        ?category.name
                                        :(typeof category.canvas !== 'undefined' && typeof category.canvas.name !== 'undefined')
                                            ?category.canvas.name
                                            :(typeof category.canvas.canvas !== 'undefined')
                                                ?category.canvas.canvas.name
                                                :null
                            }</div>
                            <div>Wettbewerb</div>
                            <div>{
                            (tournament === null)
                                ?null
                                :(typeof tournament.name !== 'undefined')
                                    ?tournament.name
                                    :(typeof tournament.canvas !== 'undefined' && typeof tournament.canvas.name !== 'undefined')
                                        ?tournament.canvas.name
                                        :(typeof tournament.canvas.canvas !== 'undefined')
                                            ?tournament.canvas.canvas.name
                                            :null
                            }</div>
                        </div>

                        {
                            (typeof event.results !== 'undefined' && event.results !== null)?
                                <Results results={event.results} event={event} />
                            :null
                        }

                        <h2>Märkte</h2>
                        <Accordion>
                        {
                            (typeof event.markets === 'undefined' || event.markets === null)?null
                            :Object.values(event.markets).map((market) => 
                                <Market onClick={() => setActiveMarket(market.uid)} active={activeMarket === market.uid} event={event} market={market} />
                            )
                        }
                        </Accordion>
                        {
                            (false && typeof event.results !== 'undefined' && event.results !== null && Object.keys(event.results).length > 0)?
                                <Fragment>
                                    <h2>Ergebnisse</h2>
                                    <div style={{
                                        display: 'grid',
                                        'grid-template-columns': '20em 1fr'
                                    }}>
                                    {
                                        Object.keys(event.results).map((resultKey) => {
                                            return (
                                                <Fragment>
                                                    <div>{resultKey}: </div><div>{
                                                        (typeof event.results[resultKey] === 'object' && Array.isArray(event.results[resultKey]))
                                                            ?event.results[resultKey].join(' : ')
                                                            :event.results[resultKey]
                                                        }
                                                    </div>
                                                </Fragment>
                                            )
                                        })
                                    }
                                    </div>
                                </Fragment>
                            :null
                        }
                    </div>
                :
                    (activeTab === 'json')?
                        <div>
                            <ReactJson src={event} />
                        </div>
                    :
                        (activeTab === 'canvas')?
                            <div>
                                {
                                    (canvasData === null)?
                                        null
                                    :
                                        <div style={{
                                            display: 'flex'
                                        }}>
                                        {
                                            (typeof canvasData.canvas !== 'undefined')?
                                                <div style={{
                                                    width: '50%'
                                                }}>
                                                    <h4>Prematch</h4>
                                                    <ReactJson src={canvasData.canvas} />
                                                </div>
                                            :null
                                        }
                                        {
                                            (typeof canvasData.resulted !== 'undefined')?
                                                <div style={{
                                                    width: '50%'
                                                }}>
                                                    <h4>Resulted</h4>
                                                    <ReactJson src={canvasData.resulted} />
                                                </div>
                                            :null
                                        }
                                        </div>
                                }
                            </div>
                        :null
            }
        </div>
        </CanvasNavigation>
    );
}